import { handleActions } from 'redux-actions';

import http from '../../shared/http';
import createPagination from '../../shared/new-pagination';

function createList({ namespace, url, perPage, getRequestQuery }) {
	if (!getRequestQuery) {
		getRequestQuery = getDefaultRequestQuery;
	}

	const pagination = createPagination({
		namespace,
		initialState: { perPage }
	});

	// action types
	const FETCH_DATA_SUCCESS = `${namespace}/fetch-data-success`;
	const FETCH_MORE_SUCCESS = `${namespace}/fetch-more-success`;
	const FETCH_DATA_ERROR = `${namespace}/fetch-data-error`;
	const TOGGLE_PROGRESS_BAR = `${namespace}/toggle-progress-bar`;
	const REMOVE_BY_ID_SUCCESS = `${namespace}/remove-by-id-success`;

	// initial state
	const initialState = {
		data: null,
		isLoading: true,
		isError: false,
		pagination: pagination.initialState
	};

	// actions
	const actions = {
		own: {
			fetchData: () => (dispatch, getState) => {
				const page = 1;
				request(getRequestQuery(page, getState), FETCH_DATA_SUCCESS)(dispatch)
					.then((action) => {
						if (action.type === FETCH_DATA_SUCCESS) {
							dispatch(pagination.actions.update({
								page,
								total: action.payload.data.total
							}));
						}
					});
			},
			fetchMore: () => (dispatch, getState) => {
				const page = getState()[namespace].pagination.currentPage + 1;
				request(getRequestQuery(page, getState), FETCH_MORE_SUCCESS)(dispatch)
					.then((action) => {
						if (action.type === FETCH_MORE_SUCCESS) {
							dispatch(pagination.actions.update({
								page,
								total: action.payload.data.total
							}));
						}
					});
			},
			removeById: (id) => (dispatch, getState) => {
				const request = http({
					url: `${url}/${id}`,
					method: 'delete',
					actions: [REMOVE_BY_ID_SUCCESS, FETCH_DATA_ERROR]
				});

				return request(dispatch).then((action) => {
					if (action.type === REMOVE_BY_ID_SUCCESS) {
						dispatch(actions.own.fetchData());
					}
				});
			},
			toggleProgressBar: () => ({ type: TOGGLE_PROGRESS_BAR })
		},
		pagination: {
			showMore: () => (dispatch, getState) => {
				dispatch(actions.own.toggleProgressBar());
				dispatch(actions.own.fetchMore());
			}
		}
	};

	const reducers = Object.assign(
		{
			[FETCH_DATA_SUCCESS]: (state, action) => ({
				...state,
				data: action.payload.data.rows,
				isLoading: false,
				isError: false
			}),
			[FETCH_MORE_SUCCESS]: (state, action) => ({
				...state,
				data: state.data.concat(action.payload.data.rows),
				isLoading: false,
				isError: false
			}),
			[FETCH_DATA_ERROR]: (state, action) => ({
				...state,
				isLoading: false,
				isError: true
			}),
			[TOGGLE_PROGRESS_BAR]: (state, action) => ({
				...state,
				isLoading: !state.isLoading
			})
		},
		pagination.reducers
	);

	// selectors
	const selectors = {
		select: (state, field) => state[namespace][field],
		getPagination: pagination.selectors.getPagination
	};

	function getDefaultRequestQuery(page, getState) {
		const state = getState()[namespace];

		const limit = state.pagination.perPage;

		return {
			offset: (page - 1) * limit,
			limit
		};
	}

	function request(query, successActionType) {
		return http({
			url,
			method: 'get',
			actions: [successActionType, FETCH_DATA_ERROR],
			query
		});
	}

	return { actions, selectors, reducers: handleActions(reducers, initialState) };
}

export default createList;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/blog/with-list/index.js